import $ from 'jquery'
import React from 'react'

const Apikey = ({ apikey, manualApikey, sentinel }) => {
  return (
    <div className='text-white' id='txt-apikey' onClick={manualApikey}>
      {apikey}
      <br />R {React.version} - jQ {$().jquery}
      <br />
      WakeLock: {sentinel != null ? 'actif' : 'inactif'}
    </div>
  )
}

export default Apikey
